/* eslint-disable @typescript-eslint/explicit-member-accessibility */
/*
 * @Descripttion:
 * @version:
 * @Author: tangshuo
 * @Date: 2022-08-26 11:37:41
 * @LastEditors: tangshuo
 * @LastEditTime: 2022-09-27 10:49:21
 */
import React, { Component, Fragment } from 'react';
import Tag from '../Tag';
import { FSTagGroupProps } from '../interface';
import './index.less';
import { Input as AInput } from '@firesoon/antd';
import { FsAddnew } from '@firesoon/icons-react';
import Input from '../../Input';

class Group extends Component<FSTagGroupProps, any> {
  static defaultProps = {
    defaultValue: [],
    hasAdd: false,
    onAdd: () => {},
    closeCallback: () => {},
  };
  private inputRef: React.RefObject<AInput>;

  constructor(props: any) {
    super(props);
    this.state = {
      inputVisiable: false,
    };
    this.inputRef = React.createRef();
  }

  handleInputConfirm = (e) => {
    const { onAdd } = this.props;
    const value: string = e.target.value;

    value && onAdd?.(value);

    this.setState({
      inputVisiable: false,
    });
  };
  showInput = () => {
    this.setState(
      {
        inputVisiable: true,
      },
      () => {
        if (this.inputRef) {
          this.inputRef.current!.focus();
        }
      },
    );
  };

  render() {
    const { defaultValue, closeCallback, hasAdd } = this.props;
    const { inputVisiable } = this.state;
    const wrapperStyle = {
      display: 'flex',
      width: '100%',
      alignItems: 'center',
      justifyContent: 'center',
    };

    return (
      <div style={wrapperStyle}>
        {defaultValue.map((item, index) => (
          <Fragment key={index}>
            <Tag borderd onClose={() => closeCallback?.(item)} {...item.tagProps}>
              {item.label}
            </Tag>
          </Fragment>
        ))}

        {hasAdd && (
          <span>
            {inputVisiable ? (
              <Input
                placeholder="请输入内容"
                ref={this.inputRef}
                size="small"
                style={{ width: 112 }}
                onBlur={this.handleInputConfirm}
                onPressEnter={this.handleInputConfirm}
              />
            ) : (
              <Tag borderd onClick={this.showInput} className="fs-tag-plus">
                <FsAddnew />
              </Tag>
            )}
          </span>
        )}
      </div>
    );
  }
}

export default Group;
